import React, { Component } from 'react';
import { Card } from 'antd';
import { connect } from 'react-redux';
import DescriptionList from '@comm/DescriptionList';
import { queryInvoiceType } from '@api/core/dict';
import { queryFilePreview } from '@api/pub/attachment';

import '../expenses.less';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
      invoiceType: [],
    };
  }

  componentDidMount() {
    this.getInvoiceType();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          invoiceType: res.data,
        });
      }
    });
  };

  findTypeName = type => {
    let typeName = '';
    this.state.invoiceType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  render() {
    const { dataItem } = this.state;
    const files = dataItem.files || [];
    return (
      <div className="form-open">
        <Card title="开票详情">
          <DescriptionList size="large" col={2}>
            <Description term="入账公司">{dataItem.income}</Description>
            <Description term="购货公司">{dataItem.company}</Description>
            <Description term="纳税人识别号">{dataItem.idCode}</Description>
            <Description term="开票类型">{this.findTypeName(dataItem.type)}</Description>
            <Description term="地址电话">{dataItem.link}</Description>
            <Description term="开票内容">{dataItem.content}</Description>
            <Description term="开户行及帐号">{dataItem.bankCode}</Description>
            <Description term="开票金额">{dataItem.price}元</Description>
            <Description term="申请人员">{dataItem.createUserName}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="开票凭证">
              <div>
                {files.map(item => {
                  return (
                    <div key={item.url}>
                      <a onClick={() => queryFilePreview(item)}> {item.name}</a>
                    </div>
                  );
                })}
              </div>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="开票说明">{dataItem.reason}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="开票备注">{dataItem.remark}</Description>
          </DescriptionList>
        </Card>
        {dataItem.codeNo && dataItem.receiver ? (
          <Card title="领票信息">
            <DescriptionList size="large" col={3}>
              <Description term="发票编号">{dataItem.codeNo}</Description>
              <Description term="领票人">{dataItem.receiver}</Description>
            </DescriptionList>
          </Card>
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/finance/invoice/FormOpen.js